import request from '@/utils/request';
import { getQwEnv, getQwSignatureApi } from '@/api/vipGiftRecommend';

async function call(path, data, token) {
  const response = await request({
    url: `${getQwEnv()}/qy-weixin-chat/complaint/${path}`,
    method: 'post', data, silentError: true, timeout: path === 'submit' ? 100000 : path === 'page' ? 65000 : 20000,
    // 独立于后台登录 Authorization，避免现有 request 拦截器覆盖页面凭证。
    headers: token ? { 'X-Complaint-Session': `Bearer ${token}` } : {},
  });
  const body = response && response.data;
  if (!body || Number(body.ret) !== 1 || !body.content) throw new Error((body && body.msg) || '页面信息查询失败');
  return body.content;
}

export const createComplaintSession = params => call('session', params);
export const attachComplaintContact = (token, externalUserid) => call('contact', { external_userid: externalUserid }, token);
export const getComplaintPage = (token, account = '') => call('page', { account }, token);
export const createComplaintUploadSession = (token, account, roleKey) => call('upload-session', { account, role_key: roleKey }, token);
export const submitComplaint = (token, data) => call('submit', data, token);
export async function uploadComplaintAttachment(session, file, onProgress, cover) {
  const data = new FormData(); data.append('file', file);
  if (cover) data.append('cover', cover, 'video-cover.jpg');
  const response = await request({ url: '/complaint/sidebar/attachments', method: 'post', data, timeout: 100000,
    silentError: true, headers: { 'X-Complaint-Upload-Session': session }, onUploadProgress: onProgress });
  const body = response && response.data;
  if (!body || Number(body.code) !== 200 || !body.data || !body.data.id) throw new Error((body && body.message) || '附件上传失败，请重试');
  return body.data;
}
export { getQwSignatureApi };
